import { useTranslation } from "react-i18next"
import { LIKERT_VARIANTS } from "../../questions/constants"
import { valueToThemeColor } from "../../utils"
import { AnswerButton } from "./AnswerButton"
import { NoAnswer } from "./NoAnswer"
import type { IAnswerProps } from "./types"

export function AnswerLikert({ answer, question }: IAnswerProps) {
  const { t } = useTranslation()

  const value = answer?.value
  if (value == null) return <NoAnswer />

  const category = question.meta?.category
  const variants = (LIKERT_VARIANTS[category] ?? LIKERT_VARIANTS.agree) as any[]
  const color = valueToThemeColor(value)
  const variant = variants.find((v) => v.value === value)

  if (!variant) return <NoAnswer />

  return (
    <AnswerButton color={color} key={variant.value}>
      {t(variant.label)}
    </AnswerButton>
  )
}
